// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3auqa","delete":"styles_delete__wMfdq","update":"styles_update__37MBh","add":"styles_add__4jXJO"};